import _ from 'lodash';
import planPageMessages from 'pages/MainPage/PlanPage/messages';
import { types } from '../generators/shapes';
import { convertToImperial, convertToMetric } from './convertMeasurement';

// Validate values with min/max.
const validateMinMax = (measurements, dimensions, limits, useImperialUnits) => _.reduce(dimensions, (errors, dimension, dimensionName) => {
  if (measurements[dimensionName] === null || isNaN(measurements[dimensionName])) {
    return errors;
  }
  const limit = limits[dimension.type];
  let minLimit;
  let maxLimit;
  let minDimension;
  let maxDimension;
  if (limit !== undefined) {
    minLimit = limit.min;
    maxLimit = limit.max;
    minDimension = dimension.min;
    maxDimension = dimension.max;
  }

  const min = Math.max(minDimension || minLimit, minLimit);
  const max = Math.min(maxDimension || maxLimit, maxLimit);
  if (measurements[dimensionName] < min) {
    let tempMin;
    if (useImperialUnits) {
      tempMin = convertToImperial(min);
    } else {
      tempMin = min;
    }
    const minVal = tempMin;
    return [...errors, {
      fields: [dimensionName],
      message: {
        ...(
          useImperialUnits 
          ? planPageMessages.errorMinimumImperial 
          : planPageMessages.errorMinimum
        ),
        values: {
          value: minVal,
        },
      },
    }];
  } else if (measurements[dimensionName] > max || (useImperialUnits && measurements[dimensionName] > max)) {
    let tempMax;
    if (useImperialUnits) {
      tempMax = convertToImperial(max);
    } else {
      tempMax = max;
    }
    const maxVal = tempMax;
    return [...errors, {
      fields: [dimensionName],
      message: {
        ...(
          useImperialUnits
          ? planPageMessages.errorMaximumImperial
          : planPageMessages.errorMaximum
        ),
        values: {
          value: maxVal,
        },
      },
    }];
  }

  return errors;
}, []);

const validateOverhang = (measurements, dimensions, limits, measurementsWithOverhang, useImperialUnits) =>
  _.reduce(measurementsWithOverhang, (errors, dimension, dimensionName) => {
    let maxLimit;
    if (useImperialUnits && limits.length.max !== undefined) {
      const imperialValMax = convertToImperial(limits.length.max);
      const diffMax = convertToMetric(imperialValMax) - limits.length.max;
      maxLimit = limits.length.max + diffMax;
    } else if (limits.length.max !== undefined) {
      maxLimit = limits.length.max;
    }
    const max = Math.min(dimension.max || maxLimit, maxLimit);
    const type = dimensions[dimensionName] !== undefined ? dimensions[dimensionName].type : undefined;
    if (type === types.LENGTH && measurementsWithOverhang[dimensionName] > max) {
      let tempMax;
      if (useImperialUnits) {
        tempMax = convertToImperial(max);
        let convertedMessage = planPageMessages.errorOverhangMaximum.defaultMessage.toString();
        convertedMessage = convertedMessage.replace('mm', '"'); //due to CA has FR language too
        planPageMessages.errorOverhangMaximum.defaultMessage = convertedMessage;
      } else {
        tempMax = max;
      }
      const maxVal = tempMax;
      return [...errors, {
        fields: [dimensionName],
        message: {
          ...(
            useImperialUnits
            ? planPageMessages.errorOverhangMaximumImperial
            : planPageMessages.errorOverhangMaximum),
          values: {
            value: maxVal,
          },
        },
      }];
    }
    if (useImperialUnits && limits.depth.max !== undefined) {
      const imperialDepthValMax = convertToImperial(limits.depth.max);
      const diffDepthMax = convertToMetric(imperialDepthValMax) - limits.depth.max;
      maxLimit = limits.length.max + diffDepthMax;
    } else if (limits.depth.max !== undefined) {
      maxLimit = limits.depth.max;
    }
    const maxDepth = limits.depth.max;
    if (type === types.DEPTH && dimension > maxLimit || (useImperialUnits && type === types.DEPTH && dimension >= maxLimit)) {
      let tempDepthMax;
      if (useImperialUnits) {
        tempDepthMax = convertToImperial(maxDepth);
      } else {
        tempDepthMax = maxDepth;                                                          // THIS ROW IS CHANGED \\
      }
      const maxDepthVal = tempDepthMax;
      return [...errors, {
        fields: [dimensionName],
        message: {
          ...planPageMessages.errorOverhangMaximum,
          values: {
            value: maxDepthVal,
          },
        },
      }];
    }
    return errors;
  }, []);

const validateLimits = (measurements, dimensions, limits, measurementsWithOverhang, useImperialUnits) => {
  const errors = [];
  if (measurementsWithOverhang) {
    errors.push(...validateOverhang(measurements, dimensions, limits, measurementsWithOverhang, useImperialUnits));
  }
  return errors.concat(validateMinMax(measurements, dimensions, limits, useImperialUnits));
};
export default validateLimits;
